module.exports = __webpack_public_path__ + "static/media/14b-03-insolada.103e81a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14b/14b-03-insolada.jpg
// module id = 151
// module chunks = 0